// Tamanho fixo do ícone gerado, independente da resolução da imagem original enviada
// (evita persistir imagens desnecessariamente grandes como Bytes no Postgres)
const OUTPUT_SIZE = 256;

// Recorta a imagem numa máscara circular e devolve um Blob PNG de tamanho fixo (OUTPUT_SIZE),
// a partir da área selecionada no Cropper (em pixels, na resolução natural da imagem)
export const cropIconToCircle = async (imageSrc, pixelCrop) => {
  if (!imageSrc || !pixelCrop) return null;

  const image = new Image();
  image.setAttribute("crossOrigin", "anonymous");
  image.src = imageSrc;
  await new Promise((resolve, reject) => {
    image.onload = resolve;
    image.onerror = reject;
  }).catch(() => null);

  const canvas = document.createElement("canvas");
  canvas.width = OUTPUT_SIZE;
  canvas.height = OUTPUT_SIZE;
  const ctx = canvas?.getContext?.("2d");
  if (!ctx) return null;

  ctx.save();
  ctx.beginPath();
  ctx.arc(OUTPUT_SIZE / 2, OUTPUT_SIZE / 2, OUTPUT_SIZE / 2, 0, Math.PI * 2);
  ctx.closePath();
  ctx.clip();

  // Escala a área recortada para preencher o canvas de saída, mantendo a posição relativa
  const escala = OUTPUT_SIZE / (pixelCrop?.width || OUTPUT_SIZE);
  ctx.drawImage(
    image,
    -(pixelCrop?.x || 0) * escala,
    -(pixelCrop?.y || 0) * escala,
    (image?.naturalWidth || OUTPUT_SIZE) * escala,
    (image?.naturalHeight || OUTPUT_SIZE) * escala,
  );
  ctx.restore();

  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        reject(new Error("Não foi possível gerar o ícone recortado."));
        return;
      }
      resolve(blob);
    }, "image/png");
  });
};
